import React from 'react';

export const Divider: React.FC = () => (
  <div className="bg-gray-300 dark:bg-gray-600 w-px h-4" />
);
